import type { SvgProps } from "../types";

export const ReceptionSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Reception</title>
      <path
        d="M136.571 142.989C143.944 211.539 134.145 281.84 127.84 350L145.518 348.746"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M139.687 144.096C143.626 212.979 104.376 204.734 194.237 191.75C200.001 200.406 204.754 201.386 208.493 194.69"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M253.557 142.989C257.655 213.669 251.047 277.327 251.047 347.786H233.905"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M254.256 142.989C258.318 167.946 267.425 185.596 259.484 191.619C252.35 197.03 221.842 191.38 203.273 189.747C197.699 189.256 197.775 191.619 194.13 191.619"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M139.992 142.989C190.489 172.7 194.683 165.508 249.373 145.36"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M125.611 64.4854C133.517 54.8738 143.577 47.7987 157.367 50.6305C196.227 58.6092 188.752 114.929 150.311 117.466C119.184 119.521 107.539 69.8212 132.667 62.8554"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M226.197 60.601C264.017 23.5343 307.537 94.0091 261.739 113.954C225.897 129.559 204.165 90.3803 226.197 67.3545"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
